<agr-powerbi-report
  [workspaceId]="workspaceId"
  [reportId]="reportId"
  [phasedEmbedding]="false"
  [eventHandlersMap]="eventHandlersMap"
></agr-powerbi-report>
